import { Loadable } from '../../Loadable';

export const AsyncAddMenuStyle = Loadable(() => import('./Add'));
export const AsyncEditMenuStyle = Loadable(() => import('./Edit'));
export const AsyncMenuStylesList = Loadable(() => import('./List'));
